import { VideoDeleteModal } from '../../labours-and-parts/components/modal';
import styles from '../styles.module.scss';
import { UserRole, VHCRecordLogDto } from 'api/generated';
import { InlineSvg } from 'components/svg';
import { useAuth } from 'features/auth/contexts/auth';
import { useCreateVhcRecordVideoMutation } from 'features/vhc/api/create-vhc-records-video.mutation';
import { useGetVhcRecordQuery } from 'features/vhc/api/get-record';
import { useRef, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import ReactPlayer from 'react-player';
import { formatDate } from 'utils/formats';

export type VideoTabProps = {
  id?: VHCRecordLogDto['id'];
  dateUploadVideo?: VHCRecordLogDto['dateUploadVideo'];
  storageVideoUrl?: VHCRecordLogDto['storageVideoUrl'];
  aWSUrl?: VHCRecordLogDto['awsUrl'];
  userNameUploadVideo?: VHCRecordLogDto['userNameUploadVideo'];
};

export const VideoTab = ({ dateUploadVideo, storageVideoUrl, aWSUrl, userNameUploadVideo, id }: VideoTabProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { refetch } = useGetVhcRecordQuery({ id: Number(id) });
  const { mutateAsync: createVideoMutation } = useCreateVhcRecordVideoMutation();
  const [isInProcess, setInProcess] = useState(false);
  const [isOpenModal, setOpenModal] = useState(false);
  const { currentUser } = useAuth();

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    setInProcess(true);
    createVideoMutation({ id: id!, formData: { Video: file } })
      .then((_) => refetch())
      .finally(() => {
        setInProcess(false);
      });
    event.target.value = null;
  };

  const handleFileSelect = () => {
    fileInputRef.current?.click();
  };

  const handleVideoDelete = async () => {
    setOpenModal(true);
  };
  const videoUrl = aWSUrl ?? storageVideoUrl;
  return (
    <div>
      {isOpenModal && (
        <VideoDeleteModal
          id={id}
          refetch={() =>
            refetch().then((_) => {
              setInProcess(false);
              setOpenModal(false);
            })
          }
          isVisible={isOpenModal}
          setInProgress={setInProcess}
          setOpenModal={setOpenModal}
        />
      )}
      <h2 className="fw-bold">Video</h2>
      {isInProcess && <Skeleton className={styles.skeleton} />}
      {videoUrl && !isInProcess && (
        <div className="w-full max-w-[515px] mx-auto pb-6">
          <ReactPlayer
            url={videoUrl}
            controls
            width="100%"
            height="auto"
            style={{ borderRadius: '12px', overflow: 'hidden' }}
            config={{
              file: {
                hlsVersion: '1.6.5'
              }
            }}
          />
        </div>
      )}
      <div>
        {dateUploadVideo && userNameUploadVideo && (
          <div className="fw-bold" style={{ color: 'gray' }}>
            Uploaded {formatDate(dateUploadVideo, 'DD MMM yyyy')} by {userNameUploadVideo}
          </div>
        )}
        <div className="d-flex flex-row gap-3 pt-5">
          <button
            style={isInProcess ? { cursor: 'not-allowed', pointerEvents: 'none' } : {}}
            onClick={handleFileSelect}
            className={`${styles['uploadVideo']} ${styles['buttonTextStyle']}`}
          >
            <span className=" pe-3">
              <InlineSvg path="/media/svg/vhc/video-upload.svg" className="svg-icon-1" />
            </span>{' '}
            {videoUrl ? 'Change Video' : 'Upload Video'}
            <input ref={fileInputRef} type="file" className=" d-none" onInput={handleFileUpload}></input>
          </button>
          {videoUrl &&
            (currentUser?.userRole === UserRole.Administrator || currentUser?.userRole === UserRole.ServiceManager) && (
              <button
                style={isInProcess ? { cursor: 'not-allowed', pointerEvents: 'none' } : {}}
                onClick={handleVideoDelete}
                className={`${styles['uploadVideo']} ${styles['buttonTextStyle']}`}
              >
                <span className=" pe-3">
                  <InlineSvg path="/media/svg/vhc/video-delete-cross.svg" className="svg-icon-1" />
                </span>{' '}
                Delete Video
              </button>
            )}
        </div>
      </div>
    </div>
  );
};
